import React__default, { createContext, useContext } from "react";
const DEFAULT_CONFIG = {
  language: "en",
  accountLanguage: "en",
  regionalFormat: "en"
};
const ConfigContext = createContext(null);
function ConfigContextProvider({
  value: configInput,
  children
}) {
  const config = {
    ...configInput,
    language: configInput.language ?? DEFAULT_CONFIG.language,
    accountLanguage: configInput.accountLanguage ?? DEFAULT_CONFIG.accountLanguage,
    regionalFormat: configInput.regionalFormat ?? DEFAULT_CONFIG.regionalFormat
  };
  return React__default.createElement(
    ConfigContext.Provider,
    { value: config },
    children
  );
}
function useConfig() {
  const context = useContext(ConfigContext);
  if (context === void 0) {
    throw new Error("useConfig must be used within a ConfigContext.Provider");
  }
  return context || DEFAULT_CONFIG;
}
export {
  ConfigContext,
  ConfigContextProvider,
  DEFAULT_CONFIG,
  useConfig
};
//# sourceMappingURL=config-context.js.map
